/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiUser } from '@Model';
import type { HttpActions, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ImportUserController.
 */
export class ImportUserRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /users:import
     */
    public getImportableUsers(): Promise<Result<ApiUser[]>> {
        return this.http.get<Result<ApiUser[]>>('/users:import');
    }

    /**
     * Calls POST /users/{sourceUserId}:import
     */
    public importUser(sourceUserId: string): Promise<Result<ApiUser>> {
        return this.http.post<Result<ApiUser>, undefined>(`/users/${sourceUserId}:import`, undefined);
    }
}
